import React from "react";
import { Phone, MessageCircle, Instagram } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { PHONE, PHONE_RAW } from "@/i18n/translations";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => {
  const { t } = useLang();
  const links = [
    { id: "about", label: t.nav.about },
    { id: "gallery", label: t.nav.gallery },
    { id: "perf", label: t.nav.perf },
    { id: "hotel", label: t.nav.hotel },
    { id: "events", label: t.nav.events },
    { id: "reserve", label: t.nav.reserve },
    { id: "careers", label: t.nav.careers },
    { id: "contact", label: t.nav.contact },
  ];

  return (
    <footer className="border-t border-white/10 bg-obsidian pt-20 pb-10 px-6 md:px-12">
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="font-display text-3xl font-700 text-white">VIP<span className="text-brand">1</span></span>
            <span className="font-body text-[10px] tracking-[0.35em] uppercase text-white/50 mt-2">Night Club</span>
          </div>
          <p className="mt-5 font-heading italic text-2xl text-white/70 max-w-sm">{t.footer.tagline}</p>
          <div className="mt-6 flex gap-3">
            <a href={`tel:+${PHONE_RAW}`} className="p-3 border border-white/15 hover:border-brand hover:text-brand text-white/70 transition-colors" aria-label="call">
              <Phone size={18} />
            </a>
            <a href={`https://wa.me/${PHONE_RAW}`} target="_blank" rel="noopener noreferrer" className="p-3 border border-white/15 hover:border-brand hover:text-brand text-white/70 transition-colors" aria-label="whatsapp">
              <MessageCircle size={18} />
            </a>
            <a href="#" className="p-3 border border-white/15 hover:border-brand hover:text-brand text-white/70 transition-colors" aria-label="instagram">
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="font-body text-xs uppercase tracking-widest text-white/40 mb-5">{t.footer.quick}</p>
          <ul className="space-y-3">
            {links.map((l) => (
              <li key={l.id}>
                <button onClick={() => scrollTo(l.id)} className="font-body text-white/65 hover:text-brand transition-colors">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-body text-xs uppercase tracking-widest text-white/40 mb-5">{t.nav.contact}</p>
          <a href={`tel:+${PHONE_RAW}`} className="font-heading text-3xl text-white hover:text-brand transition-colors">{PHONE}</a>
          <p className="mt-4 font-body text-white/50">{t.contact.hoursValue}</p>
          <p className="font-body text-white/50">{t.contact.addressValue}</p>
        </div>
      </div>

      <div className="max-w-[1600px] mx-auto mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4">
        <p className="font-body text-xs text-white/40">© {new Date().getFullYear()} VIP1 Night Club. {t.footer.rights}</p>
        <p className="font-body text-xs text-brand/80">{t.footer.legal}</p>
      </div>
    </footer>
  );
};
